import Clients from '@/settings/clients';

const checkIsDev = () => {
  return (
    window.location.port == '8080' || 
    window.location.port == '8081' ||
    Clients.devDomains.includes(window.location.hostname)
  )
}

export default {
  isDev: checkIsDev(),
  isAdmin: false,
  isMobile: false,
  mailTypes: [],
  countryList: [],
  provider: {},
  phoneProps: {
    defaultCountry: "US",
    placeholder: "Enter a phone number",
    wrapperClasses: "sm-input-tel-wrap",
    inputClasses: "sm-input-tel",
    onlyCountries: []
  },
  globalNotification: {
    type: 'notification', // types: notification, error
    text: ''
  },
  currencyList: [],
  popupOpen: false,
  reminders: null,
  notifications: null,
  announcements: null,
  apiErrors: [],
  popupError: {},
};
